export const trainingText = 'Training Starts'
export const programText = 'Program Starts'
export const yearEndText = 'School Year Ends'
